
export const schoolFiltersMap = {
  school_type: {
    label: 'Type',
    children: [
      {
        id: 'typePublic',
        label: 'Public',
        value: 'public',
      },
      {
        id: 'typePrivate',
        label: 'Private',
        value: 'private',
      },
      {
        id: 'typeCatholic',
        label: 'Catholic',
        value: 'catholic',
      },
    ],
  },
  school_level: {
    label: 'Level',
    children: [
      {
        id: 'levelElementary',
        label: 'Elementary',
        value: 'elementary',
      },
      {
        id: 'levelSecondary',
        label: 'Secondary',
        value: 'secondary',
      },
    ],
  },
  school_language: {
    label: 'Language',
    children: [
      {
        id: 'languageEnglish',
        label: 'English',
        value: 'english',
      },
      {
        id: 'languageFrench',
        label: 'French',
        value: 'french',
      },
      // {
      //   id: 'languageOther',
      //   label: 'Other',
      //   value: 'other',
      // },
    ],
  },
}


export const schoolFilterKeys = Object.keys(schoolFiltersMap)

export const schoolAllFilters = schoolFilterKeys.reduce(
  (acc, key) => {
    acc[key] = schoolFiltersMap[key].children.map(item => item.value)
    return acc
  }, {})
